import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { AlertTriangle, RefreshCw, Trash2, ChevronDown, ChevronRight } from "lucide-react";

export default function AdminErrorLogs() {
  const [logs, setLogs] = useState([]);
  const [open, setOpen] = useState({});
  const [loading, setLoading] = useState(false);

  const load = () => {
    setLoading(true);
    api.get("/admin/error-logs").then((r) => setLogs(r.data)).catch(() => {}).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const clear = async () => {
    try { const { data } = await api.delete("/admin/error-logs"); toast.success(`${data.deleted} log eliminati`); load(); }
    catch { toast.error("Errore"); }
  };

  return (
    <div className="space-y-6" data-testid="error-logs-page">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <div className="flex items-center gap-2"><AlertTriangle className="w-4 h-4 text-amber-500" /><span className="text-xs font-medium tracking-wider uppercase text-muted-foreground">Diagnostica</span></div>
          <h1 className="font-head text-3xl font-bold tracking-tight mt-1">Log Errori</h1>
          <p className="text-sm text-muted-foreground mt-1">Errori di piattaforma raccolti automaticamente (500). Utili per il supporto tecnico.</p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" className="gap-2" onClick={load} data-testid="logs-refresh"><RefreshCw className="w-4 h-4" /> Aggiorna</Button>
          <Button variant="outline" className="gap-2 text-red-500" onClick={clear} disabled={logs.length === 0} data-testid="logs-clear"><Trash2 className="w-4 h-4" /> Svuota</Button>
        </div>
      </div>

      <div className="grid gap-3">
        {logs.map((l) => {
          const isOpen = open[l.id];
          return (
            <Card key={l.id} className="p-4" data-testid={`log-row-${l.id}`}>
              <button className="w-full flex items-start justify-between gap-3 text-left" onClick={() => setOpen({ ...open, [l.id]: !isOpen })} data-testid={`log-toggle-${l.id}`}>
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-2">
                    <Badge className="bg-red-600">{l.status || 500}</Badge>
                    <Badge variant="secondary">{l.method}</Badge>
                    <span className="font-mono text-sm truncate">{l.path}</span>
                  </div>
                  <p className="text-sm text-muted-foreground mt-1 truncate">{l.message}</p>
                  <p className="text-xs text-muted-foreground mt-0.5">{(l.created_at || "").slice(0, 19).replace("T", " ")}</p>
                </div>
                {isOpen ? <ChevronDown className="w-4 h-4 shrink-0 mt-1" /> : <ChevronRight className="w-4 h-4 shrink-0 mt-1" />}
              </button>
              {isOpen && l.traceback && (
                <pre className="mt-3 p-3 rounded-lg bg-slate-950 text-slate-300 text-xs overflow-x-auto whitespace-pre-wrap">{l.traceback}</pre>
              )}
            </Card>
          );
        })}
        {logs.length === 0 && <p className="text-muted-foreground py-6 text-center">{loading ? "Caricamento…" : "Nessun errore registrato. Ottimo!"}</p>}
      </div>
    </div>
  );
}
